import "./styles.scss";
import { Handle, Position } from "@xyflow/react";
import { IconPlus } from "@tabler/icons-react";
import { Text } from "@fragments";

export default function AddReceiverNode({ data }) {
  return (
    <div className="split-add-node" onClick={() => data.onAdd?.()}>
      <Handle
        type="target"
        position={Position.Left}
        className="split-flow-handle"
      />

      <div
        className="san-card"
        style={{ animationDelay: `${(data.index ?? 0) * 70}ms` }}
      >
        <Text.h5 left={<IconPlus />} contrast={7}>
          Adicionar recebedor
        </Text.h5>
      </div>
    </div>
  );
}
